export default {
    init() {
        setupBlocks();
    }
}

function setupBlocks() {
    let $blocks = $('.block-testimonials').not('initialised');

    if ($blocks.length > 0) {
        $blocks.each((index, item) => {
            let $block = $(item);

            setupBlock($block);

            $block.addClass('initialised');
        });
    }
}

function setupBlock($block) {
    let $testimonialsCarousel = $block.find('.testimonial-carousel');

    $testimonialsCarousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            centerMode: false,
            infinite: false,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 800,
            fade: true,
            cssEase: 'ease-in-out',
            touchThreshold: 200,

            responsive: [
                {
                    breakpoint: 1920,
                    settings: {
                        centerMode: false
                    }
                }
            ]
        },
    );

}